import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchBooking } from '../../actions/booking';
import { UpdatePassengers } from '../../actions/passenger';
import { FetchProducts } from '../../actions/product';
import { FetchNationality } from '../../actions/nationality';
import { SlackWebhook } from '../../actions/utils';
import { Purchase, addAffilateId } from '../../actions/analytics';
import MastHead from '../shared/masthead';
import { SLACK_WEBHOOKS }from '../../config';
import _filter from 'lodash/filter';
import { ISOCurrencyCovert } from '../../helpers/locationHelper';
import _orderBy from 'lodash/orderBy';
import _every from 'lodash/every';
import ReactModal from 'react-modal';
import ReactGA from 'react-ga';
import LeadPassenger from './components/leadpassenger';
import PassengerItemContainer from './components/passengeritemcontainer';
import EmergencyPassenger from './components/emergencypassenger';
import { submit, getFormValues, initialize } from 'redux-form';
import { customFormErrors } from '../../helpers/formHelper';
import ConfirmationPaymentCyoa from './confirmationpaymentcyoa';
import { FetchIntineraries } from '../../actions/itineraries';
import { CYOA_NETWORK_IDS } from '../../config';

import Spinner from '../shared/spinner';
import Cookies from 'js-cookie';

class Confirmation extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      confirmModal:true,
      secondaryPaxNumber:0,
      secondaryPaxValid:false,
      passengerProcessing:false
    }
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.submitPaxDetails = this.submitPaxDetails.bind(this);

  }

  openConfirmModal(){
    ReactGA.pageview('book.busabout.com/modal/confirmation-modal');
    this.setState({confirmModal:true});
  }

  closeConfirmModal(){
    this.setState({confirmModal:false});
  }


  componentDidMount(){

    const { match: {params:{ bookingguid, bookingstatus, paymentid } }, history, FetchBooking, bookingGroup, nationality, FetchNationality, FetchProducts, FetchIntineraries } = this.props;

    //Change document title
    document.title = "Book your adventure - Confirmation";

    window.scrollTo(0, 0);

    // Load confirmation details and load products details
    // - redirect if no booking id parameter exist
    // - if no product content exist. Use default content.
    if(process.env.REACT_APP_TRANSACTION_CHECK){
      if(bookingguid === undefined || bookingstatus !== 'ACCEPT'){
        history.push('/');
      }else{
        //Fetch bookingGroup or API from API or load from state
        if(Object.keys(bookingGroup).length === 0){
          FetchBooking(bookingguid).then((data)=>{

            const TOUR_IDS = data.trips.map(item => item.tour_id).join(",");
            const HAS_CYO = _filter(data.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id})[0];


            FetchProducts(data.trips[0].iso_currency_code, TOUR_IDS);
            if(HAS_CYO !== undefined && Object.keys(HAS_CYO).length > 0) FetchIntineraries(data.cyoa_token);
          });
        }

        //Fetch nationality or load from state
        if(Object.keys(nationality).length === 0) FetchNationality();

        //check if payment reference number match the 'paymentid' url paramater
        if(Object.keys(bookingGroup).length > 0){
          if(bookingGroup.payment_transactions.length === 0 || bookingGroup.payment_transactions[0].payment_reference_number !== paymentid){
            history.push('/paymenterror/'+ bookingguid);
          }
        }


        //Add affliate id affliate tracking cookie
        addAffilateId( Cookies.get('affiliate_id') !== undefined ? Cookies.get('affiliate_id') : "", ()=>{
          Cookies.remove('affiliate_id');
        });

      }
    }else{
      //Fetch bookingGroup or API from API or load from state
      if(Object.keys(bookingGroup).length === 0){
        FetchBooking(bookingguid).then((data)=>{
          const TOUR_IDS = data.trips.map(item => item.tour_id).join(",");
          const HAS_CYO = _filter(data.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id})[0];

          FetchProducts(data.trips[0].iso_currency_code, TOUR_IDS);
          if(HAS_CYO !== undefined && Object.keys(HAS_CYO).length > 0) FetchIntineraries(data.cyoa_token);
        });
      }

      //Fetch nationality or load from state
      if(Object.keys(nationality).length === 0) FetchNationality();

    }

    //Populate initial passenger details
    this.props.initialize("EmergencyPassenger", {
      firstName:"",
      surname:"",
      emergencyPrefix:"",
      emergency:""
    });


  }


  componentDidUpdate(prevProps, prevState) {

    const {
      bookingGroup, match: {params:{ bookingguid, paymentid } },
      history, SlackWebhook, updatePassengers, emergencyPaxValues } = this.props;


    if(bookingGroup !== prevProps.bookingGroup){

      //Slack confirmation logging - production only
      if(process.env.REACT_APP_ENV === "production"){
        SlackWebhook(SLACK_WEBHOOKS.confirmation, {'text':
               '---------------------- \n' +
               'Booking confirmation: \n' +
               'PAYLOAD: ' + JSON.stringify(bookingGroup) + '\n' +
               '---------------------- \n'
           });
       }

      //Ecommerce purchase and Criteo tracking
      Purchase(bookingGroup);

      if(process.env.REACT_APP_TRANSACTION_CHECK){
        //check if payment reference number match the 'paymentid' url paramater
        if(bookingGroup.payment_transactions.length === 0 || bookingGroup.payment_transactions[0].payment_reference_number !== paymentid){
          history.push('/paymenterror/' + bookingguid);
        }
      }

      //Store secondary pax numbers
      this.setState({secondaryPaxNumber:_filter(bookingGroup.passengers, (o) => { return !o.email; } ).length});


      //Hide modal if pax already submited (when page reloaded)
      if(bookingGroup.passengers[0].emergency_contact !== null) {
        this.closeConfirmModal();
      }

    }

    //Close modal window when all pax details updated
    if(updatePassengers !== prevProps.updatePassengers){
      if(updatePassengers) this.closeConfirmModal();
    }

    //Remove emergency pax error message once field selected
    if(emergencyPaxValues !== prevProps.emergencyPaxValues){
      if(emergencyPaxValues.emergencyPrefix && emergencyPaxValues.emergencyPrefix !== ""){
        customFormErrors({
          dropdown:document.querySelector('.emergency-item .filterDropdown .filterDropdown-btn'),
          errorText:document.querySelector('.emergency-item .filterDropdown .form-error'),
          formValue:emergencyPaxValues.emergencyPrefix,
          addRemove:'remove'
        });
      }
    }

    // Check all secondary fields and emergency valid - remove double click
    this.validateSecondaryPax();
    this.validateEmergencyPax()

  }


  renderSecondaryPaxDetails(bookingGroup, form){
    if(Object.keys(bookingGroup).length !== 0){

      //Filter out lead passenger and order remaing passengers
      const _secondaryPax = _orderBy(_filter(bookingGroup.passengers, (o) => { return !o.email; } ),['first_name'], ['asc']);

      if(_secondaryPax.length > 0){
        return _secondaryPax.map( (pax, index) => { return <PassengerItemContainer key={index} paxName={pax.first_name} index={`PassengerItem${index}`} form={form} /> })
      }else{
        return null;
      }
    }
  }


  validateSecondaryPax(){

    let { secondaryPaxNumber } = this.state
    let _paxError = [];

    for(var i=0; i < secondaryPaxNumber; i++){
      let submitSucceeded = (this.props.form['PassengerItem'+i].hasOwnProperty('submitSucceeded')) ? this.props.form['PassengerItem'+i].submitSucceeded : false
      _paxError.push({isValid:submitSucceeded});
    }
    return _every(_paxError, 'isValid') ? true : false;
  }

  validateEmergencyPax(){
    return this.props.form['EmergencyPassenger'] && this.props.form['EmergencyPassenger'].hasOwnProperty('submitSucceeded');
  }

  submitPaxDetails(){

    const { bookingGroup, submit, emergencyPaxValues, UpdatePassengers, form } = this.props;

    // Validate any secondary passengers
    for(let i = 0; i < this.state.secondaryPaxNumber; i++){
       submit('PassengerItem'+ i);
    }

    //Validate emergency passenger
    submit('EmergencyPassenger');

    customFormErrors({
      dropdown:document.querySelector('.emergency-item .filterDropdown .filterDropdown-btn'),
      errorText:document.querySelector('.emergency-item .filterDropdown .form-error'),
      formValue:emergencyPaxValues.emergencyPrefix,
      addRemove:'add'
    });


    // Check all secondary fields and emergency valid
    if(this.validateSecondaryPax() && this.validateEmergencyPax()){
      this.setState({passengerProcessing:true}, () => {
        UpdatePassengers(bookingGroup, form);
      });
    }

  }


  render() {


    const { bookingGroup, bookingGroup:{passengers, trips, group_booking_id}, nationality, form, products, itineraries } = this.props;
    const { passengerProcessing } = this.state;
    const firstName = (passengers !== undefined) ? _filter(passengers, 'email')[0].first_name : '';
    const bookingDate = (trips !== undefined) ? trips[0].booking_date.split(" ")[0] : "";
    const leadPax = (passengers !== undefined) ? _filter(passengers, 'email')[0] : '';
    const _currency = (Object.keys(bookingGroup).length > 0 ) ? bookingGroup.trips[0].iso_currency_code: "";
    const _itineraries = (itineraries !== undefined && Object.keys(itineraries).length > 0) ? itineraries : "";

    return (
      <React.Fragment>
        <MastHead currencyCode={_currency} bookingGroup={bookingGroup} firstName={firstName} bookingId={group_booking_id} />
        <div className="confirmation">
          <ConfirmationPaymentCyoa bookingGroup={ bookingGroup } currency={ ISOCurrencyCovert(_currency) } product={products} itineraries={_itineraries} />
        </div>

      <ReactModal
          className="confirm-modal"
          overlayClassName="modal-overlay white scroll"
          isOpen={this.state.confirmModal}
          contentLabel="Confirm modal">

          {
          (Object.keys(bookingGroup).length === 0) ? <Spinner text="Confirmation loading..." loadClass="loading-spinner center"/> :
          <div className="row">
            <div className="column small-12 large-11 large-offset-0-5">
              <div className="row">
                <div className="column small-12">
                  <h3 className="busabout-h3 no-margin">Thanks {firstName},</h3>
                  <p className="meta-text">
                  Booking reference: {group_booking_id}  | Reservation Date: {bookingDate} <br/>
                  </p>

                  <p className="orange-text bold no-margin">Your payment was successful.</p>
                  <p className="no-margin">Before we can fully confirm your booking we need to know more about the passengers travelling with you.</p>
                  <br/>
                  <br/>
                </div>
              </div>
              <div className="confirm-modal-wrapper border-top">
                <div className="row">
                    <div className="column small-12">
                      <h5 className="busabout-h5 orange-text">Add passenger details</h5>
                      <p className="no-margin">Please enter the passenger details below. Our age policy for passenger is older than 18 year old on date of travel. </p>
                      <br/>
                    </div>
                  </div>
              </div>
              <LeadPassenger leadPax={leadPax} nationality={nationality}  />
              {this.renderSecondaryPaxDetails(bookingGroup, form)}
              <EmergencyPassenger nationality={nationality} />
              <div className="row">
                <div className="column small-12">
                  <br/>
                  <button type="submit" className="busabout--cta orange confirm-btn" onClick={this.submitPaxDetails} disabled={passengerProcessing}>
                    <span style={{display:passengerProcessing ? "none" : "block"}}>Submit &amp; View confirmation</span>
                    <span style={{display:passengerProcessing ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          }
      </ReactModal>
    </React.Fragment>
    );
  }
}

function mapStateToProps(state){
  return{
    form:state.form,
    bookingGroup:state.bookingGroup.data,
    currency:state.currency,
    products:state.products,
    emergencyPaxValues: getFormValues('EmergencyPassenger')(state),
    nationality:state.nationality,
    updatePassengers:state.updatePassengers.success,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    initialize,
    FetchBooking,
    FetchProducts,
    FetchNationality,
    SlackWebhook,
    submit,
    UpdatePassengers,
    FetchIntineraries
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);



// WEBPACK FOOTER //
// ./src/components/confirmation/confirmation.js